import React from 'react';
import {
  Dimensions,
  View,
} from 'react-native';

import * as _ht from './_ht';
import * as _cr from './_cr';

import { useKbdMsrz } from './_csKbd';

import * as _gv from './_gv';
import * as _cmABT from './_cmABT';

export const R = (pz: { // scrollView は、height の直接指定が必要
  frcUdt: () => void,
  children: React.FC
}) => {
  const _gDsnz = _gv.useDsnz();
  const _sKbdMsrz = useKbdMsrz();

  React.useEffect(() => {
    _gDsnz.set({
      pageW: Dimensions.get('window').width ?? 350,
      pageH: Dimensions.get('window').height ?? 350,
    });
  }, [])

  return (
    _cr.c(View, {
      style: {
        width: '100%',
        height: '100%',
      },
      onLayout: ( (_dz: _ht.dz) => {
        const _pageH = _dz.nativeEvent.layout.height;
        const _pageW = _dz.nativeEvent.layout.width - 1; // Edge 対応
        if ( _pageH > 0 && _pageW > 0 ) {
          if ( _sKbdMsrz.crt.bShow == false ) {
            _gDsnz.set({
              pageH: _pageH,
              pageW: _pageW,
            });
          }
          _cmABT.clr(); // レスポンシブ対応で必要
          pz.frcUdt(); // レスポンシブ対応で必要
        }
      }),
    }, [

      pz.children,

    ]
    )
  )
}
